const o = {
  defaultProps: {
    disableGutters: !0,
    elevation: 0
  },
  styleOverrides: {
    root: ({ theme: e }) => ({
      borderTop: `1px solid ${e.palette.divider}`,
      overflow: "hidden",
      "&:first-of-type": {
        borderTop: "none"
      },
      "&::before": {
        content: "none",
        display: "none"
      }
    })
  }
};
export {
  o as default
};
